export { cn } from '@health-ui/components/lib/utils';

/** Stable, component-scoped test ids. */
export function createTestIdHelper(
  componentName: string,
): (elementName?: string) => string {
  return (elementName) =>
    elementName ? `${componentName}-${elementName}` : componentName;
}
